<template>
    <div>
        <div v-if="data_ready">
            <div v-for="row in rows" class="row">
                <div v-if="show_slider">
                  <el-slider v-model="left_percent" style="margin-left:20px;margin-right:20px;"></el-slider>

                  <div class="slider-container">

                    <div class="slider left" :id="'left-'+ definition.id" style="background-color:white;">
                      <div class="slider-label">{{row[0].title}}</div>
                      <SingleFieldBarChart
                          :chart_config="row[0]"
                          :extent_id="row[0].extent_id"
                          :height="container_height"
                          :width="container_width"
                          :render_info="render_info"
                      />
                    </div>
                    <div class="slider right" :id="'right-' + definition.id" style="background-color:white;text-align:right;">
                      <div class="slider-label">{{row[1].title}}</div>
                      <SingleFieldBarChart
                          :chart_config="row[1]"
                          :extent_id="row[1].extent_id"
                          :height="container_height"
                          :width="container_width"
                          :render_info="render_info"
                      />
                    </div>
                    <div class="slider-bar" :id="'bar-' + definition.id">

                    </div>
                    <div class="slider-whitespace" :style="'z-index:-1000; ' + 'height: ' + actual_height + 'px; ' + 'width: ' + container_width + 'px; ' "></div>
                  </div>
                </div>
                <div v-else>
                  <div v-for="chart_config in row" :class="col_class">
                    {{chart_config.title}}
                    <SingleFieldBarChart
                        :chart_config="chart_config"
                        :extent_id="chart_config.extent_id"
                        :height="chart_height"
                        :width="chart_width"
                        :render_info="render_info"
                        :additional_filters="all_additional_filters(chart_config.additional_filters)"
                        @chartMetaLoaded="chartMetaLoaded($event)"
                        :render_ready="max_ready"
                    />
                  </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: "ReportCompSmallMult",
        props: ['definition','container_height','container_width','additional_filters'],
        data() {
            return {
                data_ready: false,
                rows: null,
                components: [],
                render_info: {
                    display_extra: false,
                    global_max_1: null,
                },
              left_percent: 50,
              show_slider: false,
              count_components: 1000000,
              got_meta: [],
              global_max_1: null,
              global_max_2: null,
              max_ready: false,
            }
        },
        watch: {
          left_percent () {
            let path = "polygon(0 0, PERCENT% 0%, PERCENT% 100%, 0% 100%)".replaceAll('PERCENT',this.left_percent)
            document.getElementById('left-' + this.definition.id).style["clip-path"] = path
            this.setBar()
          }
        },
        methods: {
          all_additional_filters(chart_config_filters) {
            console.log('here come the chart config filters')
            console.log(chart_config_filters)
            return chart_config_filters
          },
          setBar() {
            document.getElementById('bar-' +  this.definition.id).style["margin-left"] =
                (this.left_percent/100 * (this.slider_width))
                    .toString() + 'px'
            document.getElementById('bar-' +  this.definition.id).style["height"] = (this.actual_height).toString() + 'px'
          },
          chartMetaLoaded(payload) {
            console.log('back in ReportCompSmallMult, got this:')
            console.log(payload)
            let key = payload.key
            let meta = payload.meta
            // No idea how this would happen, but there seem to be cases where we receive a payload with a key
            // but with no meta (and then a second emit sends with the data to us) -- so we will just ignore
            // when we get no meta
            if (meta && meta.hasOwnProperty('maximums')) {
              console.log('got meta')
              // global_max_1
              let this_metric_1 = parseFloat(meta.maximums.metric1)
              if (this.global_max_1 === null) this.global_max_1 = this_metric_1
              else if (this_metric_1 > this.global_max_1) this.global_max_1 = this_metric_1

              // global_max_2
              let this_metric_2 = parseFloat(meta.maximums.metric2)
              if (this.global_max_2 === null) this.global_max_2 = this_metric_2
              else if (this_metric_2 > this.global_max_2) this.global_max_2 = this_metric_2

              if (!this.got_meta.includes(key)) {
                this.got_meta.push(key)
              }
              if (this.got_meta.length === this.count_components) {
                this.render_info.global_max_1 = this.global_max_1
                this.render_info.global_max_2 = this.global_max_2
                this.max_ready = true
              }
            } else {
              console.log('skipping key ' + key + ' since it contains no metadata.')
            }
          },
        },
        computed: {
            col_class: function () {
                let cols = 12 / this.definition.details.interior_columns
                return "col-md-" + cols
            },
            chart_height: function() {
                return this.container_height / this.definition.details.interior_columns
            },
            chart_width: function() {
                return this.container_width / this.definition.details.interior_columns
            },
            actual_height: function() {
              return this.container_height + 30
            },
            slider_width: function() {
                return this.container_width + 20
            }
        },
        mounted() {
            axios.get('/reports/small_multiples/' + this.definition.details_id + '/' + this.definition.details.flattened_table_id)
                .then(response => {
                    this.components = response.data
                    if (this.definition.details.type === 1) { // if LIST small multiples
                        // this logic of putting into rows and columns is almost identical to code in Report.vue
                        this.rows = []
                        let current_row = []
                        let row_internal_col_max = this.definition.details.interior_columns
                        let row_internal_col_count = 0
                        let count = 0
                        this.components.forEach(component => {
                            if (row_internal_col_count >= row_internal_col_max) {
                                this.rows.push(current_row)
                                current_row = []
                                row_internal_col_count = 0
                            }
                            count = count + 1
                            component.css_id = "chart-" + count
                            current_row.push(component)
                            row_internal_col_count = row_internal_col_count + 1
                        })
                        this.rows.push(current_row)
                        this.data_ready = true
                        if (this.definition.details.interior_columns===2 && this.definition.details.interior_rows===1) {
                          this.show_slider = true
                          this.$nextTick(() => this.setBar());
                        }
                        this.count_components = count
                    }
                })
                .catch(error => {
                    console.error(error)
                    console.log('oops getting small multiples expanded')
                })
        },
    }
</script>

<style scoped>

</style>